// src/app/modules/user/components/modals/ConfirmationModal.tsx
import React from 'react'
import {Modal, Form} from 'react-bootstrap'
import PrimaryButton from '../common/buttons/PrimaryButton'

interface ConfirmationModalProps {
  isLoading?: boolean
  isDanger?: boolean
  isOpen: boolean
  title: string
  message: string
  confirmButtonTitle: string
  onConfirm: () => void
  onCancel: () => void
  /** when true, renders a textarea bound to `notes` + `onNotesChange` */
  requireNotes?: boolean
  notes?: string
  onNotesChange?: (val: string) => void
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isLoading = false,
  isDanger = true,
  isOpen,
  title,
  message,
  confirmButtonTitle,
  onConfirm,
  onCancel,
  requireNotes = false,
  notes = '',
  onNotesChange = () => {},
}) => {
  return (
    <Modal show={isOpen} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || 'Confirm Action'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='mb-2'>{message}</p>
        {requireNotes && (
          <Form.Group controlId='confirmNotes'>
            <Form.Control
              as='textarea'
              rows={3}
              value={notes}
              onChange={(e) => onNotesChange(e.target.value)}
              placeholder='Enter a reason for this action'
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton
          color='secondary'
          className='text-white'
          onClick={onCancel}
        >
          Cancel
        </PrimaryButton>
        <PrimaryButton
          color={isDanger ? 'danger' : 'success'}
          disabled={(requireNotes && notes.trim().length === 0) || isLoading}
          onClick={onConfirm}
        >
          {!isLoading ? confirmButtonTitle : 'Processing...'}
        </PrimaryButton>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
